export interface ITranslation {
    key: string,
    value: string
}

export enum LanguageEnum {
    en = "en",
    et = "et"
}



// WEBPACK FOOTER //
// ./src/models/translation.ts